(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["google-reviews-live"] && !Shopify.designMode) return;
  try {
    (function () {
    var ENDPOINT = '/tools/rv/google-reviews';
    var TIMEOUT_MS = 8000;
    // The app proxy answers in about a second, so start about a screen and a
    // half early; the reviews are then usually in place on arrival.
    var LOAD_AHEAD = '1200px 0px';
    var request;

    // One request per page view; every carousel on the page shares it.
    function requestReviews() {
      if (request) return request;
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = controller ? window.setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;
      request = fetch(ENDPOINT, {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('Google reviews request failed with HTTP ' + response.status + '.');
        return response.json();
      }).then(readSelection).finally(function () {
        if (timer) window.clearTimeout(timer);
      });
      return request;
    }

    // null when the app has no current reviews (an expected state shown on
    // its admin page); throws when the answer is not what the app sends.
    function readSelection(data) {
      if (!data || typeof data.available !== 'boolean' || !Array.isArray(data.reviews)) {
        throw new Error('Google reviews response is invalid.');
      }
      if (!data.available) return null;
      var valid = data.reviews.length >= 3 && data.reviews.every(function (review) {
        return review && typeof review.text === 'string' && review.text.trim() !== '' &&
          (review.name === null || typeof review.name === 'string');
      });
      var summary = data.summary;
      if (summary !== null && !(summary && typeof summary.averageRating === 'number' &&
          isFinite(summary.averageRating) && typeof summary.totalReviewCount === 'number' &&
          summary.totalReviewCount > 0)) {
        valid = false;
      }
      if (!valid) throw new Error('Google reviews response is invalid.');
      return { reviews: data.reviews, summary: summary };
    }

    // The carousel loader is a deferred script that can run after this one,
    // so wait for it rather than show the slides as a stacked list.
    function carouselRuntime() {
      return new Promise(function (resolve) {
        var settled = false;
        function attempt() {
          if (settled || !window.themeSwiperLoad) return settled;
          settled = true;
          window.themeSwiperLoad().then(resolve, function () { resolve(null); });
          return true;
        }
        if (attempt()) return;
        document.addEventListener('DOMContentLoaded', attempt, { once: true });
        window.addEventListener('load', function () {
          if (!attempt()) {
            settled = true;
            resolve(null);
          }
        }, { once: true });
      });
    }

    function reviewSlides(root, reviews) {
      var template = root.querySelector('template[data-google-review-template]');
      return reviews.map(function (review) {
        var slide = template.content.firstElementChild.cloneNode(true);
        var quote = slide.querySelector('[data-review-text]');
        var text = document.createElement('p');
        text.className = 'review-card__text';
        text.textContent = review.text;
        quote.textContent = '';
        quote.appendChild(text);
        var author = slide.querySelector('.review-card__author');
        if (review.name) author.textContent = review.name;
        else author.parentNode.removeChild(author);
        return slide;
      });
    }

    function ownSlides(root) {
      var template = root.querySelector('template[data-google-review-fallback]');
      if (!template) return [];
      return Array.prototype.slice.call(template.content.cloneNode(true).children);
    }

    function showSlides(root, slides, runtime) {
      var placeholder = root.querySelector('[data-google-review-placeholder]');
      if (placeholder) placeholder.parentNode.removeChild(placeholder);
      root.removeAttribute('aria-busy');
      if (!slides.length) {
        var section = root.closest('[data-google-reviews-section]');
        if (section) section.hidden = true;
        return;
      }
      slides.forEach(function (slide) { root.appendChild(slide); });
      if (window.themeSwiperPrepare) window.themeSwiperPrepare(root);
      if (runtime) runtime.update(root);
      root.dispatchEvent(new CustomEvent('review-cards:update', { bubbles: true }));
    }

    function showSummary(root, summary) {
      if (!summary) return;
      var scope = root.closest('[data-google-reviews-section]') || document;
      Array.prototype.forEach.call(scope.querySelectorAll('[data-google-reviews-summary]'), function (element) {
        element.textContent = (element.getAttribute('data-template') || '')
          .split('[rating]').join(summary.averageRating.toFixed(1))
          .split('[count]').join(summary.totalReviewCount.toLocaleString('en-AU'));
        element.classList.remove('is-pending');
      });
    }

    function whenNear(root, callback) {
      if (typeof IntersectionObserver !== 'function') {
        callback();
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        callback();
      }, { rootMargin: LOAD_AHEAD });
      observer.observe(root);
    }

    function load(root) {
      var selection = requestReviews().catch(function (error) {
        console.error('Google reviews could not be loaded; showing the section\'s own reviews.', error);
        return null;
      });
      Promise.all([selection, carouselRuntime()]).then(function (results) {
        var chosen = results[0];
        showSlides(root, chosen ? reviewSlides(root, chosen.reviews) : ownSlides(root), results[1]);
        showSummary(root, chosen && chosen.summary);
      });
    }

    function start(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-google-reviews]:not([data-google-reviews-started])'), function (root) {
        root.setAttribute('data-google-reviews-started', '');
        whenNear(root, function () { load(root); });
      });
    }

    document.addEventListener('shopify:section:load', function (event) { start(event.target); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { start(); });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["review-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function measure(root) {
      Array.prototype.forEach.call((root || document).querySelectorAll('[data-review-card]'), function (card) {
        if (card.classList.contains('is-expanded')) return;
        var text = card.querySelector('[data-review-text]');
        if (text) card.classList.toggle('is-clamped', text.scrollHeight > text.clientHeight + 1);
      });
    }

    // Delegated, so it also works on the copies the carousel makes for looping.
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-review-more]');
      if (!button) return;
      var card = button.closest('[data-review-card]');
      var expanded = card.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? 'Show less' : 'Read more';
      var carousel = card.closest('.google-reviews-carousel');
      if (carousel) {
        carousel.classList.toggle('has-expanded', !!carousel.querySelector('.review-card.is-expanded'));
      }
      if (!expanded) measure(card.parentNode);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { measure(); }, 150);
    });
    document.addEventListener('shopify:section:load', function (event) { measure(event.target); });
    // Cards added after the page loaded (google-reviews-live); measured again
    // once the carousel has laid them out.
    document.addEventListener('review-cards:update', function (event) {
      measure(event.target);
      window.setTimeout(function () { measure(event.target); }, 1000);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { measure(); });
    } else {
      measure();
    }
    // The carousel adds its looping copies after it starts.
    window.addEventListener('load', function () {
      measure();
      window.setTimeout(function () { measure(); }, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
